import { Box, CircularProgress, CircularProgressProps } from "@mui/material";
import "./circularProgress.css";
export const CircularProgressWithLabel = (
  props: CircularProgressProps & { value: number }
) => {
  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-flex",
        borderRadius: "35px",
        backgroundColor: "#eeeeeeaa",
        padding: "2px",
      }}
      onClick={props.onClick}
    >
      <CircularProgress
        variant="determinate"
        {...props}
        size={props.size || 70}
        sx={{ color: "#EA8B8B" }}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <p className="percentage">{Math.round(props.value)}%</p>
      </Box>
    </Box>
  );
};
